<template>
<div>
    <div class="full">
        <div class="mainheader">
            <div class="half">
                {{ $t('pages.comp.planOptions') }}
            </div>
            <!-- <div class="half right">
                <div class="full">
                    <b-button style="display: inline;" pill variant="outline-success" @click="showModal('modal-createfile')">
                        <i class="fas fa-upload"></i>&nbsp;&nbsp;Hochladen
                    </b-button>
                </div>
            </div> -->
        </div>
    </div>
    <!-- EMPLOYEE TYPE -->
    <div class="full split-bottom">
        <div class="header">
            <div class="label">{{ $t('pages.comp.workRestTimesAutomaticPlanning') }}</div>
        </div>
        <div class="half left">
            <div class="fourth">
                <div class="label m4-top">{{ $tc('pages.employeeContext.planning') }}</div>
            </div>
            <div class="threefourths" style="z-index: 990;">
                <dropdownsearch id="wizard-employeeType" :state="filtersEmployeeType"/>
            </div>
        </div>
    </div>
    <div v-if="employeetype != null" class="full">
        <div class="half left">
            <div class="full">
                <div class="half">
                    <div class="full" v-if="contract && contract.pregnant">
                        <div class="label">{{ $t('pages.comp.pregnantLimits') }}</div>
                        <div class="label data">{{ $t('global.ui.yes') }}</div>
                    </div>
                    <div class="full">
                        <div class="label">{{ $t('pages.employeeContract.monthWorkTime') }}</div>
                        <div class="label data">{{employeetype.monthTimeRegular / 60}}</div>
                    </div>
                    <div class="full">
                        <div class="label">{{ $t('pages.comp.weeklyWorkTime') }}</div>
                        <div class="label data">{{ contract ? (contract.pregnant ? Math.min(40, employeetype.weekTimeRegular / 60) : employeetype.weekTimeRegular / 60) : employeetype.weekTimeRegular / 60}}</div>
                    </div>
                    <div class="full">
                        <div class="label">{{ $t('pages.comp.regularHoursDaily') }}</div>
                        <div class="label data">{{ contract ? (contract.pregnant ? (Math.min(storeSettings.country == 2 ? 8.5 : (storeSettings.country == 1 ? 9*60 : 8*60), employeetype.dayTimeRegular/60)) : employeetype.dayTimeRegular / 60) : employeetype.dayTimeRegular / 60}}</div>
                    </div>
                    <div class="full">
                        <div class="label">{{ $t('pages.comp.workDaysPerWeek') }}</div>
                        <div class="label data">{{employeetype.weekWorkDaysRegular}}</div>
                    </div>
                </div>
                <div class="half">
                    <div class="full">
                        <div class="label">{{ $t('pages.comp.exceedMonthlyHours') }}</div>
                        <div class="label data">{{employeetype.monthTimeMaxType? $t('pages.comp.allowed') : $t('pages.comp.notAllowed') }}</div>
                    </div>
                    <div class="full">
                        <div class="label">{{ $t('pages.comp.maxWeeklyHours') }}</div>
                        <div class="label data">{{contract ? (contract.pregnant ? 40 : employeetype.weekTimeMax / 60) : employeetype.weekTimeMax / 60}}</div>
                    </div>
                    <div class="full">
                        <div class="label">{{ $t('pages.comp.maxDailyHours') }}</div>
                        <div class="label data">{{contract ? (contract.pregnant ? (Math.min(storeSettings.country == 2 ? 8.5 : (storeSettings.country == 1 ? 9*60 : 8*60), employeetype.dayTimeMax/60)) : employeetype.dayTimeMax / 60) : employeetype.dayTimeMax / 60}}</div>
                    </div>
                    <div class="full">
                        <div class="label">{{ this.$t('workBalance.summary.target') + ' ' + $t('pages.comp.workDaysPerWeek') }}</div>
                        <div class="label data">{{employeetype.weekWorkDaysRegular}}</div>
                    </div>
                    <div class="full" v-if="employeetype.weekWorkDaysMax > -1">
                        <div class="label">{{ $t('roster.comp.maxDaysWeek') }}</div>
                        <div class="label data">{{employeetype.weekWorkDaysMax}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="half right">
            <div class="full">
                <div class="full">
                    <div class="label">{{ $t('pages.comp.breakBetweenShifts') }}</div>
                    <div class="label data">{{ employeetype.restTime /60 + ' Stunden' }}</div>
                </div>
                <div class="full">
                    <div class="label">{{ $t('pages.comp.restTimePerWeek') }}</div>
                    <div class="label data">{{ employeetype.weekSpareTimeMin / 60 + ' Stunden' }}</div>
                </div>
                <div class="full">
                    <div class="label">{{ $t('pages.comp.minFreeDaysPerWeek') }}</div>
                    <div class="label data">{{ employeetype.weekSpareDaysMin }}</div>
                </div>
                <div class="full" v-if="employeetype.daysConsecutiveMax > 0">
                    <div class="label">{{ $t('pages.comp.daysConsecutiveMax') }}</div>
                    <div class="label data">{{ employeetype.daysConsecutiveMax > 0? employeetype.daysConsecutiveMax : 'N/A' }}</div>
                </div>
            </div>
        </div>
    </div>
    <!-- END EMPLOYEE TYPE -->

    <!-- EMPLOYEE RULES -->
    <div class="full split-bottom">
        <div class="header">
            <div class="label">{{ $t('pages.comp.freeTimePreferences') }}</div>
        </div>
        <div class="half left">
            <div class="fourth">
                <div class="label m4-top">{{ $t('global.general.settings') }}</div>
            </div>
            <div class="threefourths" style="z-index: 989;">
                <dropdownsearch id="wizard-employeeType" :state="filtersEmployeeRules"/>
            </div>
        </div>
    </div>
    <div class="full" v-if="employeerules != null">
        <div class="half left">
            <div class="full">
                <div v-for="rule in rulesLeft()" v-bind:key="rule.id" class="full">
                    <div class="label">{{ rule.description + (isRuleActive(rule.id)? '  [ ' + ruleValue(rule.id) + ' ]' : '') }}</div>
                    <i class="fas fa-check-circle checkbox" v-bind:class="{'true' : isRuleActive(rule.id), 'false' : !isRuleActive(rule.id)}" style="pointer: default; pointer-events: none;"></i>
                </div>
            </div>
        </div>

        <div class="half right">
            <div class="full">
                <div v-for="rule in rulesRight()" v-bind:key="rule.id" class="full">
                    <div class="label">{{ rule.description + (isRuleActive(rule.id)? '  [ ' + ruleValue(rule.id) + ' ]' : '')  }}</div>
                    <i class="fas fa-check-circle checkbox" v-bind:class="{'true' : isRuleActive(rule.id), 'false' : !isRuleActive(rule.id)}" style="pointer: default; pointer-events: none;"></i>
                </div>
            </div>
        </div>
    </div>
    <!-- END EMPLOYEE RULES -->
    <!-- EMPLOYEE YOUTH WORK CONFIG -->
    <div class="full" v-if="isUnderage">
        <div class="header">
            <div class="label">{{ $t('pages.employeeData.youthWorkConfig') }}</div>
        </div>
        <div class="half left">
            <div class="fourth">
                <div class="label m4-top">{{ $t('global.ui.setting') }}</div>
            </div>
            <div class="threefourths" style="z-index: 990;">
                <dropdownsearch id="wizard-employeeType" :state="filtersYouthWorkConfig"/>
            </div>
        </div>
        <div v-if="employeeYouthWorkConfig != null" class="full">
            <div class="full split-bottom" v-for="rule in employeeYouthWorkConfig.rules" v-bind:key="rule.id">
                
                <div class="half left">
                    <div class="full">
                        <div class="label">{{ $t('global.ui.age') }}</div>
                        <div class="label data">{{ $t('pages.comp.underYearsX', [rule.maxAge]) }}</div>
                    </div>
                    <div class="full">
                        <div class="label">{{ $t('pages.comp.maxWeeklyHours') }}</div>
                        <div class="label data">{{rule.weekTimeMax / 60}}</div>
                    </div>
                    <div class="full">
                        <div class="label">{{ $t('pages.comp.maxDailyHours') }}</div>
                        <div class="label data">{{rule.dayTimeMax / 60}}</div>
                    </div>
                    <div class="full">
                        <div class="label">{{ $t('global.ui.minShort') + ' ' + $t('global.menubar.sortOptionShiftStart')}}</div>
                        <div class="label data">{{rule.startTimeMin}}</div>
                    </div>
                </div>
                <div class="half right">
                    <div class="full">
                        <div class="label">{{ $t('pages.comp.breakBetweenShifts') }}</div>
                        <div class="label data">{{ rule.restTime /60 + ' Stunden' }}</div>
                    </div>
                    <div class="full">
                        <div class="label">{{ $t('pages.comp.restTimePerWeek') }}</div>
                        <div class="label data">{{ rule.weekSpareTimeMin / 60 + ' Stunden' }}</div>
                    </div>
                    <div class="full">
                        <div class="label">{{ $t('pages.comp.minFreeDaysPerWeek') }}</div>
                        <div class="label data">{{ rule.weekSpareDaysMin }}</div>
                    </div>
                    <div class="full">
                        <div class="label">{{ $t('pages.comp.endTimeMax') }}</div>
                        <div class="label data">{{rule.endTimeMax}}</div>
                    </div>
                </div>
            </div>
        </div>

        
    </div>
    <!-- EMPLOYEE YOUTH WORK CONFIG -->
</div>
</template>

<script>
import dropdownsearch from '../../uicomponents/dropdownsearch.vue'
import { mapState, mapGetters } from 'vuex';
export default {
    components: {
        dropdownsearch,
    },
    name: 'employeeplantype',
    data() {
        return {

            loading: true,
           
          
            availableRules: {
                desiredR: this.$t('pages.comp.considerPreferences'),
                undesiredR: this.$t('pages.comp.considerDislikes'),
                weekendR: this.$t('store.templates.freeWeekends'),
                weekendDaysR: this.$t('pages.comp.DistributionWeekendDays'),
                skillR: this.$t('pages.comp.considerSkills'),
                fairnessDefinitionR: this.$t('pages.comp.considerFairness'),
                bioR: this.$t('pages.comp.considerBiorhythm')
            },
            itemsEmployeeType: [],
            filtersEmployeeType: {},
            itemsEmployeeRules: [],
            filtersEmployeeRules: {},
            filtersYouthWorkConfig: {},
            youthWorkConfig: null,
        }
    },
    computed: {
        ...mapGetters([
            'storeId',
            'employeeMap',
            'youthWorkConfigMap',
            'allowedContractMap',
            'employeeTypeTemplateMap',
            'isSuperUser'
        ]),
        employeeYouthWorkConfig(){
            let result = null;
            if(this.employee != null && this.employee.youthWorkConfigId){
                result = Object.values(this.youthWorkConfigMap).find(ywc => ywc.id == this.employee.youthWorkConfigId)
            }
            if(result == null && this.storeSettings.defaultYouthWorkConfig){
                result = Object.values(this.youthWorkConfigMap).find(ywc => ywc.id == this.storeSettings.defaultYouthWorkConfig)
            }
            if(result == null){
                Object.values(this.youthWorkConfigMap).find(ywc => ywc.country == this.storeSettings.country && ywc.base)
            }
            return result;
        },
        isUnderage: function() {
            let result = false;
            if(this.employee != null && this.employee.dob != null){
                let endOfMonth = this.$helpers.getMomentTZ().endOf('month');
                if(this.rosterFromTo != null && this.rosterFromTo.to != null){
                    endOfMonth = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
                }
                let dobMoment = this.$helpers.getMomentFromStringTZ(this.employee.dob);
                let dob18yearsMoment = dobMoment.add(18, 'years').add(1, 'month');
                return endOfMonth < dob18yearsMoment;
            }
            return result;
        },
    },
    watch: {
        
        employee: {
            deep: true,
            handler (val, oldVal){
                this.updateEmployeeTypeDropdown();
                this.updateEmployeeRulesDropdown();
                this.updateEmployeeYouthWorkConfigDropdown();
                this.$forceUpdate();
            }
        }
    },
    props: [
        "employee",
        "contract",
        "employeetype",
        "employeerules",
        "employeerulesObj",
        "employeetypes",
        "storeSettings",
        "allEmployeeRules"
    ],
    created() {
        this.updateEmployeeTypeDropdown();
        this.updateEmployeeRulesDropdown();
        this.updateEmployeeYouthWorkConfigDropdown();
    },
    destroyed() {
        var settings = this;
        
        if (document.querySelector('#imgupload')) document.querySelector('#imgupload').removeEventListener('change', settings.ProcessImageUpload);
        if (document.querySelector('#imguploadpublic')) document.querySelector('#imguploadpublic').removeEventListener('change', settings.ProcessImageUploadPublic);
        
    },
    methods: {

        ruleValue(ruleId){
            if(this.employeerules && ruleId in this.employeerules){
                var rule = this.employeerules[ruleId];
                return rule;
            }
            return 0;
        },
        isRuleActive(ruleID) {
            if (this.employeerules) {
                return ruleID in this.employeerules && this.ruleValue(ruleID) > 0;
            }
            return false;
        },
        rulesLeft() {
            var keys = Object.keys(this.availableRules);
            var count = keys.length;
            var rl = [];
            if (count > 0) {
                var div = Math.floor(count / 2);
                for (var i = 0; i < count - div; i++) {
                    var cur = {};
                    cur.id = keys[i];
                    cur.description = this.availableRules[keys[i]];
                    rl.push(cur)
                }
            }
            return rl;
        },
        rulesRight() {
            var keys = Object.keys(this.availableRules);
            var rl = [];
            var count = keys.length;
            if (count > 0) {
                var div = Math.floor(count / 2);
                for (var i = div + 1; i < count; i++) {
                    var cur = {};
                    cur.id = keys[i];
                    cur.description = this.availableRules[keys[i]];
                    rl.push(cur);
                }
            }
            return rl;
        },
        updateEmployeeType(employeeType){
            let view = this;

            // update employee type
            let url = '/api/sec/employee/linkemployeetype';
            let params = {
                storeId: this.$store.state.storeId
            }
            
            
            let payload = {
                'id': this.employee.id,
                'linkId': employeeType.id
            }
            
            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload,
                params: params,
            }).then(response => {
                view.$emit('employeetype-updated', this.employee.id, employeeType);
                if(response.data.type && response.data.type == 'SUCCESS'){
                    view.$helpers.success(view.$t('global.notifications.saved'), view.$t('global.ui.editedX', [view.$t('pages.employeeContract.planningEmployeeType')]));
                }else{
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.editedErrorX', [view.$t('pages.employeeContract.planningEmployeeType')]));
                }
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.editedErrorX', [view.$t('pages.employeeContract.planningEmployeeType')]));
                console.log(error)
            });
        },
        updateEmployeeRules(ruleId){
            let view = this;
            // update employee type
            let url = '/api/sec/employee/linkemployeerules';
            let params = {
                storeId: this.$store.state.storeId
            }
            
            
            let payload = {
                'id': this.employee.id,
                'linkId': ruleId
            }

            view.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload,
                params: params,
            }).then(response => {
                view.$emit('employeerules-updated', this.employee.id, ruleId);
                if(response.data.type && response.data.type == 'SUCCESS'){
                    this.$helpers.success(view.$t('global.notifications.saved'), view.$t('global.ui.edited', [view.$tc('global.ui.setting', 2)]));
                }else{
                    this.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.editedErrorX', [view.$tc('global.ui.setting', 2)]));
                }
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.editedErrorX', [view.$tc('global.ui.setting', 2)]));
                console.log(error)
            });
        },
        openLinkDefaultModal(){
            let view = this;
            let description = this.$t('pages.comp.linkToPlanningGuidesQuery') + " <br/>";
            let employeeItems = Object.values(this.employeeMap).filter(e => e.active).map(e => {return {label: e.lastName +" "+e.firstName, value: e.id, selected: true}});
            employeeItems.sort((a,b)=> {
                if(a.label.toLowerCase() < b.label.toLowerCase()){
                    return -1;
                } else if (a.label.toLowerCase() < b.label.toLowerCase()){
                    return 1;
                }
                return 0;
            })                  
            let dataEntries = [];
            dataEntries.push(
                {
                    label: this.$tc('global.general.employee'), key: 'ids', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: employeeItems,
                        input: '',
                        items: employeeItems,
                        selectMultiple: true,
                        selectedItems: employeeItems,
                        selectedItem: {},
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('global.ui.selectEmployee'),
                    }
                }
            );
            

            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: description,
                    selectCallback: function (data) {
                        
                        if (data.ids.length > 0){
                            let payload = {ids: data.ids};
                             view.assignDefaultTypes(payload);
                        }
                       
                            
                    }
                },
                header: this.$t('pages.comp.linkPlanningGuides'),
                expanded: true,
                centered: true
             });
            
        },
        assignDefaultTypes(data){
            let view = this;
            let url = '/api/sec/employee/linkdefault';
            
            let params = {
                storeId: view.$store.state.storeId,
                
            }
            
            view.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url,
                data: data
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.comp.planningGuidesLinked'));
                view.$emit('refresh', null, true, true);
                
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.comp.linkPlanningGuidesError'));
                
             });
        },
        updateEmployeeTypeDropdown() {
            var view = this;
            this.itemsEmployeeType = [];
            var selectedItem = {};
            this.employeetypes.sort((a, b) =>b.weekTimeRegular - a.weekTimeRegular).forEach(val =>{
                let active = this.employeeTypeTemplateMap[val.templateId].contractId == null || this.allowedContractMap[this.employeeTypeTemplateMap[val.templateId].contractId].active
                var cur = {
                    code: val,
                    label: val.name,
                    name: val.name,
                    obj: val
                };
                if(this.employeetype && val.id == this.employeetype.id) {
                    selectedItem = cur;
                }
                if(active || selectedItem == cur){
                    this.itemsEmployeeType.push(cur);
                }
                
            })
            this.itemsEmployeeType.push({
                code: null,
                label: this.$t('global.ui.none_f'),
                name: 'Keine',
                obj: {id: null}
            })
            
            this.filtersEmployeeType = {
                toggled: false,
                displayedItems: this.itemsEmployeeType,
                input: this.employeetype != undefined ? this.employeetype.name : this.$t('global.ui.pleaseSelect'),
                items: Object.values(this.itemsEmployeeType),
                onceSelected: function ($event, item, searchbar) {
                    console.log(item);
                    view.updateEmployeeType(item.obj);
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
        updateEmployeeRulesDropdown(){
            var view = this;
            this.itemsEmployeeRules = [];
            
            var selectedItem = {};
            for (const val of this.allEmployeeRules) {
                var cur = {
                    code: val.id,
                    label: val.name,
                    name: val.name,
                    obj: val.rules
                };
                if(this.employeerulesObj && val.id == this.employeerulesObj.id){
                    selectedItem = cur;
                }
                this.itemsEmployeeRules.push(cur);
            }
            this.itemsEmployeeRules.sort((a, b) => {
                return a.label.localeCompare(b.label);
            })
            this.itemsEmployeeRules.push({
                code: null,
                label: this.$t('global.ui.none_f'),
                name: 'Keine',
                obj: null
            })
            this.filtersEmployeeRules = {
                toggled: false,
                displayedItems: this.itemsEmployeeRules,
                input: this.employeerulesObj ? this.employeerulesObj.name : this.$t('global.ui.pleaseSelect'),
                items: Object.values(this.itemsEmployeeRules),
                onceSelected: function ($event, item, searchbar) {
                    view.updateEmployeeRules(item.code);
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },

        updateEmployeeYouthWorkConfig(youthWorkConfig){
            let view = this;
            let url = '/api/sec/employee/linkemployeeyouthworkconfig';
            let params = {
                storeId: view.$store.state.storeId
            }
            
            
            let payload = {
                'id': view.employee.id,
                'youthWorkConfigId': youthWorkConfig.id
            }

            view.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+view.$store.state.jwt
                },
                url: url,
                data: payload,
                params: params,
            }).then(response => {

                view.$emit('employeeyouthworkconfig-updated', this.employee.id, youthWorkConfig);
                if(response.data.type && response.data.type == 'SUCCESS'){
                    view.$helpers.success(view.$t('global.notifications.saved'), view.$t('global.ui.editedX', [this.$t('pages.comp.underageConfig')]));
                }else{
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.editedErrorX', [this.$t('pages.comp.underageConfig')]));
                }
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.editedErrorX', [this.$t('pages.comp.underageConfig')]));
                console.log(error)
            });
        },
        updateEmployeeYouthWorkConfigDropdown() {
            var view = this;
            
            let itemsEmployeeYouthWorkConfig = Object.values(this.youthWorkConfigMap)
            .filter(ywc => ywc.country == this.storeSettings.country)
            .map(ywc => {
                return {
                    label: ywc.name,
                    value: ywc.id,
                    obj: ywc,
                    selected: view.employeeYouthWorkConfig != null ? (ywc.id == view.employeeYouthWorkConfig.id) : false
                }
            });
            let selectedItem = itemsEmployeeYouthWorkConfig.find(ywc => ywc.selected);
           
            this.filtersYouthWorkConfig = {
                toggled: false,
                displayedItems: itemsEmployeeYouthWorkConfig,
                input: this.youthWorkConfig != undefined ? this.youthWorkConfig.name : this.$t('global.ui.pleaseSelect'),
                items: itemsEmployeeYouthWorkConfig,
                onceSelected: function ($event, item, searchbar) {
                    console.log(item);
                    
                    view.updateEmployeeYouthWorkConfig(item.obj);
                },
                selectedItem: selectedItem,
                styleLight: true,
                noBorder: false,
            }
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/*
.content *:not(.main-settings)>.half {
    height: 105px;
}
*/
</style>
